import { ColoursObj, getContrastYIQ, TextInputField } from "@eventr/common-storybook";
import i18n from "i18n/i18next";
import { useHeaderStore, useQuery } from "state/headerState/header.store";
import { Utils } from "utils";

export const HeaderSearchBar = () => {
  const query = useQuery();
  return (
    <TextInputField
      id="searchBarId"
      onClick={() => {
        Utils.hapticFeedback("light");
      }}
      iconLeft={<SearchBarIcon />}
      placeholder={i18n.t("general.search")}
      onChange={(props) => {
        useHeaderStore.getState().setQuery(props.currentTarget.value);
      }}
      value={query}
      autoComplete="off"
    />
  );
};

interface ISearchBarProps {
  onChange: (value: string) => void;
  value: string;
  onClick?: () => void;
  autoFocus?: boolean;
  /** Distinct id per instance: two bars on screen at once must not share one. */
  id?: string;
  inputRef?: React.Ref<any>;
  placeholder?: string;
}
export const SearchBar = ({
  onChange,
  value,
  onClick,
  autoFocus,
  id = "searchBarId",
  inputRef,
  placeholder,
}: ISearchBarProps) => {
  return (
    <TextInputField
      id={id}
      onClick={() => {
        Utils.hapticFeedback("light");
        onClick?.();
      }}
      iconLeft={<SearchBarIcon />}
      placeholder={placeholder ?? i18n.t("general.search")}
      onChange={(props) => {
        onChange(props.currentTarget.value);
      }}
      inputProps={{ autoFocus: autoFocus }}
      inputRef={inputRef}
      value={value}
      autoComplete="off"
    />
  );
};

// TODO: Add to storybook.
const SearchBarIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10ZM13.594 16.0082C12.5434 16.6379 11.314 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 11.8276 16.2996 13.4916 15.1526 14.7383L19.2071 18.7929C19.5976 19.1834 19.5976 19.8166 19.2071 20.2071C18.8166 20.5976 18.1834 20.5976 17.7929 20.2071L13.594 16.0082Z"
        fill={getContrastYIQ(ColoursObj.backgrounds.header, ColoursObj.shades.shade2, ColoursObj.shades.shade2)}
      />
    </svg>
  );
};
